import React from 'react';
import { useTranslation } from 'react-i18next';
import Dropdown from '../util/Dropdown';
import { AddButton } from '../util/buttons';
import ImmutableUnderReviewFormCheck from '../util/reviewEditControls/ImmutableUnderReviewFormCheck';

/**
 * Single table row for selecting a user access (from dropdown), showing their details,
 * engagement team checkbox, and submit button to add the selected user to participations.
 */
const UserSelectorRow = _ref => {
  var _selectedUserAccess$i, _selectedUserAccess$r, _selectedUserAccess$u, _selectedUserAccess$u2;
  let {
    userAccessOptions,
    selectedUserAccess,
    onSelectionChange,
    onEngagementTeamChange,
    onSubmit,
    participations
  } = _ref;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Dropdown, {
    name: "user_access_id",
    fieldName: "user_access_id",
    dataTestId: "contacts_user_access_dropdown",
    value: (_selectedUserAccess$i = selectedUserAccess === null || selectedUserAccess === void 0 ? void 0 : selectedUserAccess.id) !== null && _selectedUserAccess$i !== void 0 ? _selectedUserAccess$i : '',
    onChange: value => onSelectionChange({
      value: value !== null && value !== void 0 ? value : ''
    }),
    options: userAccessOptions,
    showNullOption: true,
    size: "md",
    className: "p-0 border-0",
    style: {
      minWidth: '200px',
      borderColor: '#80bbdc'
    }
  })), /*#__PURE__*/React.createElement("td", null, selectedUserAccess === null || selectedUserAccess === void 0 || (_selectedUserAccess$r = selectedUserAccess.roles) === null || _selectedUserAccess$r === void 0 ? void 0 : _selectedUserAccess$r.map(r => t(r)).join(',')), /*#__PURE__*/React.createElement("td", null, selectedUserAccess === null || selectedUserAccess === void 0 || (_selectedUserAccess$u = selectedUserAccess.user) === null || _selectedUserAccess$u === void 0 ? void 0 : _selectedUserAccess$u.email), /*#__PURE__*/React.createElement("td", null, selectedUserAccess === null || selectedUserAccess === void 0 || (_selectedUserAccess$u2 = selectedUserAccess.user) === null || _selectedUserAccess$u2 === void 0 ? void 0 : _selectedUserAccess$u2.phone_number), /*#__PURE__*/React.createElement("td", null, selectedUserAccess && /*#__PURE__*/React.createElement(ImmutableUnderReviewFormCheck, {
    name: "included_in_engagement_team",
    onChange: e => onEngagementTeamChange(selectedUserAccess, e),
    checked: selectedUserAccess === null || selectedUserAccess === void 0 ? void 0 : selectedUserAccess.included_in_engagement_team,
    disabled: true
  })), /*#__PURE__*/React.createElement("td", null, selectedUserAccess && /*#__PURE__*/React.createElement(AddButton, {
    onClick: () => onSubmit(selectedUserAccess, participations)
  })));
};
export default UserSelectorRow;